export const contactFormulierNL = {
  "ContactFormulier.VoorMijzelfIkBenKlant": "Voor mijzelf. Ik ben klant bij het CAK.",
  "ContactFormulier.VoorIemandAndersDieKlantIs": "Voor iemand anders die klant is bij het CAK.",
  "ContactFormulier.VoorMijzelfIkBenGeenKlant": "Voor mijzelf. Ik ben geen klant bij het CAK."
};
